<template>
  <div class="manager-comments-section p-2 mx-n2">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center pb-2">
        <SectionTitle>
          指導者間コメント
        </SectionTitle>
      </div>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <p class="fs-s mb-2">
        ※面談内容や指導者間の申し送りなど、ここへのコメントは選手には見えません
      </p>
      <div
        class="d-flex flex-column">
        <CommentItem
          v-for="managerComment in comments"
          :key="managerComment.id"
          :comment="managerComment"
          :login-user-id="user.id"
          @delete="deleteManagerComment" />
        <CommentInput
          :id="userId"
          ref="managerCommentInput"
          field-id="user"
          class="mt-2"
          @submit="addManagerComment">
          <template #submit>
            <BaseButton
              class="mt-3"
              color="pink"
              type="submit">
              指導者間コメントを追加
            </BaseButton>
          </template>
        </CommentInput>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import CommentInput from '@/components/view/CommentInput.vue'
import CommentItem from '@/components/view/CommentItem.vue'
import BaseButton from '@/components/parts/BaseButton.vue'
export default {
  components: {
    SectionTitle,
    CollapseButton,
    CommentInput,
    CommentItem,
    BaseButton,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    comments: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isCollapseOpen: true,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    addManagerComment(formData) {
      if (!window.confirm('このコメントはメンバー本人も見れません。指導者だけが閲覧できるコメントです。よろしいですか？')) return
      this.$store.commit('startLoading')
      return this.$axios.post('/profiles/manager-comments/', formData).then(() => {
        this.$emit('refetch')
        this.$refs.managerCommentInput.reset()
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    deleteManagerComment(commentId) {
      if (!window.confirm('コメントを削除してもよろしいですか?')) return
      this.$store.commit('startLoading')
      this.$axios.delete(`/profiles/manager-comments/${commentId}/`).then(() => {
        this.$emit('refetch')
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.manager-comments-section {
  background-color: $warning-background;
}
</style>

<style lang="scss">
.btn-pink {
  background-color: $pink !important;
  color: $white !important;
  &:hover {
    background-color: $pink !important;
    color: $white !important;
  }
}
</style>